<template>
    <base-modal
        :reference="'addSubzone_' + pickupzone.id"
        :title="'Añadir resort'"
        :acceptAction="acceptAction"
        :cancelActionText="'Cerrar'"
        :size="'md'"
    >
        <template v-slot:body v-if="show">
            <div>
                <p>
                    Añadir un nuevo resort en la subzona de recogidas de <strong>{{pickupzone.name}}</strong>
                </p>
            </div>
            <form>
                
                <div class="d-flex w-100 my-3">
                    <div class="d-flex flex-column align-items-sm-baseline">
                        <label>Nombre del resort de recogidas <span class="text-danger">* [campo obligatorio]</span></label>
                        <b-form-input
                            type="text"
                            v-model="form.name"
                            placeholder="Inserte nombre"
                            style="width: 17vw"
                        ></b-form-input>
                    </div>
                </div>
                <div v-if="errors">
                    <p class="alert-danger py-2 px-4 my-2 font-weight-bold w-75 mx-auto">
                        El campo nombre es obligatorio
                    </p>
                </div>
            </form>
        </template>

    </base-modal>

</template>

<script>
/* eslint-disable */
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";


export default {
    components: {
        BaseModal,
    },
    props: {
        pickupzone: {
            type: Object,
            required: false,
        }
    },
    data() {
        return {
            show: false,
            form: {
                name: ''
            }
        }
    },
    async mounted() {
        this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
            const current = "addSubzone_" + this.pickupzone.id;
            if (modalId == current) {
                this.show = true
            }
        })
    },
    methods: {
        async acceptAction() {
            if ( this.errors ) {
                return 
            }
            
            let data = {
                suprazone_id: this.pickupzone.supra_zone,
                payload: {
                    pickup_zone: this.pickupzone.id,
                    ...this.form
                }
            }
            console.log(data)
            await this.$store.dispatch("subzones/createSubzone", data )
            
            // reset form data
            this.form = {
                name: '',
            }

            this.$bvModal.hide("addSubzone_" + this.pickupzone.id);
            this.$notify({
                group: "foo",
                title: "Resort añadido",
                text: "Se ha creado un nuevo resort de recogidas",
                type: "success",
            });
        }
    },
    computed: {
        errors() {
            if ( this.form.name == '') {
                return true
            }
            return false
        }
    }
}
</script>